class SiteFooter extends HTMLElement {
  constructor() {
    super();

    let openAccordionButtons = this.querySelectorAll('.footer-block__title');

    for (let openAccordionButton of openAccordionButtons) {
      openAccordionButton.addEventListener('click', (e) => {
        e.preventDefault();
        openAccordionButton.nextElementSibling.classList.toggle('active');
        openAccordionButton.classList.toggle('active');
      });
    }
  }
}

if (!customElements.get('site-footer')) {
  customElements.define('site-footer', SiteFooter);
}
